import { uuid } from "@/utils/uuid"
import { analytics } from "./amplitude"

export class ProcessingPerformance {
	private startedAt?: number
	private lastFinishedAt?: number
	private processedCount = 0
	private failedCount = 0
	private finished = false
	private sourceExtensionCounts = new Map<string, number>()

	constructor(
		private operation: "export" | "culling" | "ai_style",
		private properties: {
			projectId?: string
			styleId?: string
			triggerSource?: string | null
			outputFormat?: string
			destination?: "local" | "pixieset"
		},
	) {}

	start() {
		if (!this.finished) this.startedAt ??= Date.now()
	}

	processed(sourceFilename?: string) {
		if (this.finished) return
		this.processedCount++
		this.lastFinishedAt = Date.now()
		if (sourceFilename != null) {
			let extension = sourceFilename.includes(".")
				? sourceFilename.split(".").at(-1)?.toLowerCase() || "unknown"
				: "unknown"
			if (this.operation !== "export") {
				extension = extension === "jpg" ? "JPEG" : extension.toUpperCase()
			}
			this.sourceExtensionCounts.set(
				extension,
				(this.sourceExtensionCounts.get(extension) ?? 0) + 1,
			)
		}
	}

	failed() {
		if (this.finished) return
		this.failedCount++
		this.lastFinishedAt = Date.now()
	}

	finish(reason: "completed" | "canceled" | "failed") {
		if (this.finished) return
		this.finished = true
		if (this.startedAt == null) return

		try {
			analytics.trackEvent({
				label: `${this.operation}_processing_finished`,
				type: "event",
				customProperties: {
					...this.properties,
					runId: uuid(),
					// Stop at the last result, excluding later UI/cleanup time.
					wallTimeMs: Math.max(0, (this.lastFinishedAt ?? Date.now()) - this.startedAt),
					processedCount: this.processedCount,
					failedCount: this.failedCount,
					reason,
					...(this.operation === "export"
						? { sourceExtensionCounts: Object.fromEntries(this.sourceExtensionCounts) }
						: { fileFormatInfo: Object.fromEntries(this.sourceExtensionCounts) }),
				},
			})
		} catch (error) {
			console.warn("Unable to report processing performance", error)
		}
	}
}
